<template>
  <div>
    <div class="dashboard-kpi p-2">
      <div class="text-bold text-center">
        Supplier Satisfaction Index - User Confirmation
      </div>
      <div class="pointer" style="position:absolute;right:3%; top: 2%;" @click="downloadReport()">
        <i class="fa-solid fa-file-arrow-down" style="color:red;  font-size: large;"></i>
      </div>
      <div class="doughnat-container">
        <!-- <div class="text-in-chart">{{ labels }} %</div> -->
        <pie-chart :chartData="chart[`chartData`]" :options="chart[`chartOptions`]"
          :styles="{ height: '75%', listStyleType: 'none' }" @click.native="handleLegendClick()" v-if="ssiCount" />
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
export default {
  components: {
    PieChart: () => import('@/components/chart/dashboard/pie-chart.vue'),
  },
  data() {
    return {
      labels: 0,
      chart: {
        chartData: {
          labels: ['Confirm', 'Waiting to Confirm'],
          datasets: [
            {
              backgroundColor: ['#D3100C', '#F33'],
              data: [48, 3],
            },
          ],
        },

        chartOptions: {
          legend: {
            position: 'right',
            labels: {
              generateLabels(chart) {
                const data = chart.data
                if (data.labels.length && data.datasets.length) {
                  return data.labels.map((label, i) => {
                    const dataset = data.datasets[0]
                    const percentage = (
                      (dataset.data[i] / dataset.data.reduce((a, b) => a + b)) *
                      100
                    ).toFixed(2)
                    return {
                      text: `${dataset.data[i]} (${isNaN(percentage) ? 0 : percentage
                        }%) - ${label}`,
                      fillStyle: dataset.backgroundColor[i],
                      hidden:
                        isNaN(dataset.data[i]) ||
                        chart.getDatasetMeta(0).data[i].hidden,
                      lineCap: 'round',
                    }
                  })
                }
                return []
              },
            },
          },
          tooltips: {
            callbacks: {
              label(tooltipItem, data) {
                const dataset = data.datasets[tooltipItem.datasetIndex]
                const total = dataset.data.reduce(
                  (previousValue, currentValue) => previousValue + currentValue
                )
                const currentValue = dataset.data[tooltipItem.index]
                const percentage = Math.round((currentValue / total) * 100)
                return `${dataset.data[tooltipItem.index]} (${percentage}%)`
              },
            },
          },
        },
      },
    }
  },
  computed: {
    ssiCount() {
      const data = this.$store.state.kpiStore.ssiCount
      this.convertData(data.total_user_confirm)

      return data
    },
    confirmLevel2() {
      return this.$store.state.kpiStore.ssiCount.user_confirm_level_2;
    },
  },
  methods: {
    handleLegendClick(index) {
      const label = this.chart[`chartData`].labels[1]

      if (label === 'Waiting to Confirm') {
        this.$emit('changeContent', 'waiting_to_confirm')
      } else {
        return
      }
    },
    checkStatus(value) {
      switch (value) {
        case '0':
          return 'Belum Konfirmasi';
          break;
        case '1':
          return 'Konfirmasi PIC 1';
          break;
        case '2':
          return 'Konfirmasi PIC 2';
          break;

        default:
          return 'Belum Konfirmasi'
          break;
      }
    },
    convertData(data) {
      let confirm = 0
      let waiting = 0
      let total = 0
      let percentage = 0

      if (data && data.length > 0) {
        for (let value of data) {
          if (value.status == 'confirm') {
            confirm += value.jumlah
          } else if (value.status == 'waiting') {
            waiting += value.jumlah
          }

          if (percentage < Number(value.persentase).toFixed(2)) {
            percentage = Number(value.persentase).toFixed(2)
          }

          total += value.jumlah
        }

        const chartData = {
          labels: ['Confirm', 'Waiting to Confirm'],
          datasets: [
            {
              backgroundColor: ['#D3100C', '#F33'],
              data: [confirm, waiting],
            },
          ],
        }

        this.chart = {
          ...this.chart,
          chartData,
        }
      } else {
        const chartData = {
          labels: ['Confirm', 'Waiting to Confirm'],
          datasets: [
            {
              backgroundColor: ['#D3100C', '#F33'],
              data: [0, 0],
            },
          ],
        }

        this.chart = {
          ...this.chart,
          chartData,
        }
      }

      this.labels = percentage
    },
    downloadReport() {
      const exportTitle = 'SSI - User Confirmation'
      let newData = this.confirmLevel2.map((item, index) => {
        let newDataItem = {
          no: index + 1,
          PCR_GROUP: item.PCR_GROUP,
          PIC_1: item.PIC_1,
          EMAIL_PIC_1: item.EMAIL_PIC_1,
          PIC_2: item.PIC_2,
          EMAIL_PIC_2: item.EMAIL_PIC_2,
          STATUS_PIC: this.checkStatus(item.STATUS_PIC),
        }

        return newDataItem
      })

      // newData.unshift({})

      let wb = XLSX.utils.book_new()
      let sheet = [exportTitle]
      sheet.forEach(list => {
        let dataToExport = XLSX.utils.json_to_sheet(newData)
        const title = [
          ['NO', 'PCR GRUP', 'PIC 1', 'EMAIL PIC 1', 'PIC 2', 'EMAIL PIC 2', 'STATUS KONFIRMASI']
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `${exportTitle}.xlsx`)
    },
  },
}
</script>

<style scoped>
.doughnat-container {
  display: flex;
  justify-content: center;
  align-items: center;

  margin: 60px auto;
  width: 100%;
  max-width: 40vw;
  height: 100%;
  max-height: 50vh;
  background-color: rgb(237, 231, 231);
  border-radius: 8px;
  box-shadow: 0 1px 5px 3px gray;
  cursor: pointer;
}

.text-in-chart {
  position: absolute;
  top: 50%;
  left: 30%;
  font-size: 1rem;
  color: #d3100c;
  font-weight: 700;
}
</style>
